import React, { SVGProps } from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Notice } from '../services/useSellerNotice';

interface DefaultNoticeProps {
  notice: Notice;
  headerTitle: string;
  NoticeIcon: ({ width, height, color, ...props }: SVGProps<SVGSVGElement>) => JSX.Element;
}

export const DefaultNotice: React.FC<DefaultNoticeProps> = ({ notice, NoticeIcon, headerTitle }) => {
  return (
    <Container>
      <BannerBlock>
        <Header>
          <NoticeIcon color={vars.v3Color.staticBlack} />
          <span>{headerTitle}</span>
        </Header>
        <Content>
          <NoticeTitle>{notice.title}</NoticeTitle>
          <NoticeContent>{notice.content}</NoticeContent>
        </Content>
      </BannerBlock>
    </Container>
  );
};

// 기존 구조 그대로 유지
const Container = styled.div`
  padding: 24px 16px;
  position: relative;
`;

const BannerBlock = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 136px;
  padding: 10px;
  border: 1px solid ${vars.v3Color.gray150};
  border-radius: 4px;
  background-color: ${vars.v3Color.staticWhite};
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  background-color: ${vars.v3Color.gray50};
  border-radius: 4px;
  color: ${vars.v3Color.staticBlack};
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;

  svg {
    margin: 0 10px 0 0;
    width: 24px;
    height: 24px;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 10px 10px;
`;

const NoticeTitle = styled.h3`
  margin: 0 0 10px;
  font-weight: 600;
  font-size: 13px;
  text-align: center;
  color: ${vars.v3Color.gray900};
  white-space: pre-wrap;
  word-break: break-all;
`;

const NoticeContent = styled.p`
  font-weight: 400;
  font-size: 13px;
  text-align: center;
  color: ${vars.v3Color.gray700};
  white-space: pre-wrap;
  word-break: break-all;
`;
